<template>
  <div class="bootstrap-wrapper">
    <div class="container pt-5">
      <div class="path">
        <DirPath :path="['']" />
      </div>
      <div class="" style="border: 0;">
        <div class="row align-center">
          <div class="col-1 px-1">
            <unicon
              name="user-circle"
              width="70"
              height="70"
              :fill="grayCol"
              v-if="userData && !userData.avatar"
            />
            <img
              width="70"
              height="70"
              :src="
                require(`@/assets/avatar/Avatar ${userData.avatar}/Avatar-${userData.avatar}.gif`)
              "
              class="avatar-img transition-all"
              v-if="userData && userData.avatar"
            />
          </div>
          <div class="col-11">
            <h4 class="text-barlow-condensed my-0">
              {{
                $t(
                  userData
                    ? userData.genre == "MALE"
                      ? "welcomeM"
                      : "welcomeF"
                    : "welcomeM"
                )
              }}
            </h4>
            <h3 class="mb-0 mt-2 subheader text-barlow-condensed">
              <template v-if="userData">
                {{ userData.firstname }}
                {{ userData.lastname }}
              </template>
              <template v-else>
                Profesor(a)
              </template>
              <div v-if="ownerSchoolSelected">
                Colegio: {{ userData.school.name }}
              </div>
            </h3>
            <p class="small">{{ $t("analyticsText")[0] }}</p>
          </div>
        </div>
      </div>

      <div class="row my-5 d-flex justify-content-center align-items-end">
        <div class="col-md-4">
          <div class="">
            <div>
              <router-link
                :to="'/dashboard/analytics/workSession'"
                v-slot="{ href, route, navigate }"
              >
                <img
                  :href="href"
                  @click="navigate"
                  class="image-item svg-color-gray pointer"
                  src="@/assets/images/noun_start up.svg"
                />
              </router-link>
            </div>
            <div>
              <h4 class="text-barlow-condensed text-center text-container">
                {{ $t("analyticsText")[1] }}
              </h4>
            </div>
            <div>
              <p class="text-left mb-4 text-gray card-subtitle"></p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="">
            <div>
              <router-link
                :to="'/dashboard/analytics/reports'"
                v-slot="{ href, route, navigate }"
              >
                <img
                  :href="href"
                  @click="navigate"
                  class="image-item svg-color-gray pointer"
                  src="@/assets/images/noun_report.svg"
                />
              </router-link>
            </div>
            <div>
              <h4 class="text-barlow-condensed text-center text-container">
                {{ $t("analyticsText")[2] }}
              </h4>
            </div>
            <div>
              <p class="text-left mb-4 text-gray card-subtitle"></p>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="">
            <div>
              <router-link
                :to="'/dashboard/analytics/diagnostics'"
                v-slot="{ href, route, navigate }"
              >
                <img
                  :href="href"
                  @click="navigate"
                  class="image-item svg-color-gray pointer"
                  src="@/assets/images/noun_validation.svg"
                />
              </router-link>
            </div>
            <div>
              <h4 class="text-barlow-condensed text-center text-container">
                {{ $t("analyticsText")[3] }}
              </h4>
            </div>
            <div>
              <p class="text-left mb-4 text-gray card-subtitle"></p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";

export default {
  name: "analytics",
  components: {
    DirPath,
    FooterComponent,
  },
  data() {
    let { grayCol } = this.$store.getters;

    return {
      grayCol,
    };
  },
  computed: {
    ...mapState(["userData", "ownerSchoolSelected", "dataUrl", "logoutUrl"]),
  },
  methods: {
    ...mapMutations(["setTeacherData", "setToken"]),
  },
};
</script>

<style lang="scss" scoped>
.image-item {
  width: 100% !important;
  max-height: 25vh;
}
.button-20px {
  font-size: 20px;
}
@media screen and (min-width: 1024px) {
  .path {
    display: none;
  }
}

.text-container {
  height: 70px;
}
</style>
